/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectType } from './subjectType.model';
import { HouseNumberType } from './houseNumberType.model';


export interface MergedSubject { 
    castObce?: string;
    cisloDomovni?: number;
    cisloOrientacni?: string;
    comparisonString?: string;
    contactId?: number;
    cpCe?: HouseNumberType;
    ico?: string;
    id?: number;
    jmeno?: string;
    mestskaCast?: string;
    nazev?: string;
    obec?: string;
    okres?: string;
    opsubType?: SubjectType;
    payoutRent?: boolean;
    prijmeni?: string;
    psc?: string;
    rodneCislo?: string;
    stat?: string;
    titulPredJmenem?: string;
    titulZaJmenem?: string;
    ulice?: string;
    uliceKompletni?: string;
    userName?: string;
}
export namespace MergedSubject {
}


